export var NodeVariant;
(function (NodeVariant) {
    NodeVariant[NodeVariant["RECT"] = 0] = "RECT";
    NodeVariant[NodeVariant["DIAMOND"] = 1] = "DIAMOND";
    NodeVariant[NodeVariant["ROUND"] = 2] = "ROUND";
})(NodeVariant || (NodeVariant = {}));
export var NodeColor;
(function (NodeColor) {
    NodeColor["TEXT_LIGHT"] = "#fff";
    NodeColor["TEXT_DARK"] = "#000";
    NodeColor["GREY"] = "#b6bdc6";
    NodeColor["WHITE_BLUE"] = "#f0f4fc";
    NodeColor["LIGHT_BLUE"] = "#6d8ce2";
    NodeColor["PURPLE"] = "#4c61c6";
})(NodeColor || (NodeColor = {}));
export var LinkLineVariant;
(function (LinkLineVariant) {
    LinkLineVariant["LINE"] = "LINE";
    LinkLineVariant["DASHED_LINE"] = "DASHED_LINE";
})(LinkLineVariant || (LinkLineVariant = {}));
export var LinkArrowVariant;
(function (LinkArrowVariant) {
    LinkArrowVariant["NONE"] = "NONE";
    LinkArrowVariant["ARROW_HEAD"] = "ARROW_HEAD";
    LinkArrowVariant["CLOSED_ARROW_HEAD"] = "CLOSED_ARROW_HEAD";
})(LinkArrowVariant || (LinkArrowVariant = {}));
//# sourceMappingURL=types.js.map